import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/MedicalReferrals';

export interface IMedicalReferral {
  id?: number;
  openDate: Date;
  part: string;
  hasFile: boolean;
  requestNumber: number;
  statusCode: number;
  statusDate: Date;
  supplierName: string;
  validFromDate: Date;
  validToDate: Date;
  isActive: boolean;
  invalidationDate?: Date;
}

interface IFileRequest {
  contentType?: string;
  fileContentBase64?: string;
  documentName?: string;
}

export const getMedicalReferrals = async () => {
  const medicalReferrals = await api.get<IMedicalReferral[]>(
    addImposterToUrl(`${baseURL}`, true)
  );
  if (medicalReferrals.data) return medicalReferrals.data;
};

export const requestFile = async (RequestNumber: number) => {
  const fileResult = await api.get<IFileRequest>(
    addImposterToUrl(`${baseURL}/${RequestNumber}/file`, true)
  );
  if (fileResult.data) return fileResult.data;
};
